<template>
  <div>
    <div v-show="dashboardEnable || isFakeUser">
      <v-toolbar
        class="elevation-0"
        height="30px"
        style="margin-bottom: 10px; background-color: transparent"
      >
        <v-toolbar-items>
          <v-menu offset-y>
            <v-btn
              v-show="shops.length > 1"
              slot="activator"
              flat
              class="q-orange-bk q-text-whitesmoke no-cradius"
              style="margin-right: 10px"
              >{{ getString("Scegli negozio") }}</v-btn
            >
            <v-list>
              <v-list-tile
                v-for="(item, index) in shops"
                :key="index"
                @click="setShop(item)"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn
            flat
            class="q-orange-bk q-text-whitesmoke no-cradius"
            style="margin-right: 10px"
            @click="toggleCards(true)"
            >{{ getString("Nascondi tutto") }}</v-btn
          >
          <v-btn
            flat
            class="q-orange-bk q-text-whitesmoke no-cradius"
            @click="toggleCards(false)"
            >{{ getString("Mostra tutto") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-switch
            class="hidden-sm-and-down"
            color="red lighten-3"
            :label="getString('2 Col.')"
            v-model="multi"
          ></v-switch>
        </v-toolbar-items>
      </v-toolbar>
      <h1 v-show="shops.length === 0">
        {{ getString("Nessun negozio scelto") }}
      </h1>
      <v-layout row wrap v-show="shops.length > 0">
        <v-flex :lg4="multi" :xs12="!multi">
          <stats-shop-card
            ref="shopCard"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
          ></stats-shop-card>
        </v-flex>
        <v-flex :lg8="multi" :xs12="!multi">
          <stats-emp-card
            ref="empCard"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
          ></stats-emp-card>
        </v-flex>
        <v-flex :lg6="multi" :xs12="!multi">
          <stats-lasts-card
            ref="lastsCard"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
          ></stats-lasts-card>
        </v-flex>
        <v-flex :lg6="multi" :xs12="!multi">
          <stats-ladder-card
            ref="ladderCard"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
          ></stats-ladder-card>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="dashboardDisable">
      <v-card-title class="no-padding" slot="header">
        <v-toolbar color="red lighten-2" style="text-align: center">
          <span class="headline q-text-whitesmoke text-center">{{
            getString(`Attenzione`)
          }}</span>
        </v-toolbar>
      </v-card-title>
      <v-card-text slot="body">
        <v-layout wrap>
          <v-flex xs12>
            <span class="headline">{{
              getString(`Per vedere la dashboard inserisci la tua password.`)
            }}</span>
          </v-flex>
        </v-layout>
        <v-progress-linear
          indeterminate
          v-show="isLoading"
          :active="isLoading"
          :height="2"
        ></v-progress-linear>
        <v-text-field
          v-model="password"
          type="password"
          placeholder="la tua password"
        ></v-text-field>
      </v-card-text>
      <v-card-actions slot="footer">
        <v-btn
          class="q-orange"
          :disabled="isLoading"
          flat
          @click="checkPassword()"
          >{{ getString("Conferma") }}</v-btn
        >
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import StatsEmpCard from "./pieces/StatsEmpCard";
import StatsShopCard from "./pieces/StatsShopCard";
import StatsLastsCard from "./pieces/StatsLastsCard";
import StatsLadderCard from "./pieces/StatsLadderCard";
import Modal from "../utils/ModalQ";
import ajax from "../../ajax";
export default {
  name: "Dashboard",
  components: {
    StatsEmpCard,
    StatsShopCard,
    StatsLastsCard,
    StatsLadderCard,
    Modal,
  },
  mounted: function () {
    if (this.shops.length > 0) {
      this.setShop(this.shops[0]);
      this.checkAvaibility();
    }
  },
  computed: {
    shops: function () {
      return this.$store.state.userShops;
    },
    idBarberShop: function () {
      if (this.shops.length > 0) {
        return this.shops[0].idBarberShop;
      }
      return 0;
    },
    isFakeUser: function () {
      console.log("isFakeUser:", this.$store.getters.isFakeUser);
      return this.$store.getters.isFakeUser;
    },
  },
  data: () => {
    return {
      h: null,
      multi: true,
      dashboardDisable: false,
      dashboardEnable: false,
      isLoading: false,
      password: "",
    };
  },
  watch: {
    shops: function (newvalue, oldvalue) {
      if (this.shops.length > 0) {
        this.setShop(this.shops[0]);
        this.checkAvaibility();
      }
    },
  },
  methods: {
    checkPassword: function () {
      let self = this;
      this.isLoading = true;
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/user/checkPassword/",
          {
            password: self.password,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.dashboardEnable = true;
          self.dashboardDisable = false;
          self.setShop(self.shops[0]);
        })
        .catch(function (error) {
          console.log(error.message);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
      this.isLoading = false;
    },
    setShop: function (shop) {
      for (var prop in this.$refs) {
        // skip loop if the property is from prototype
        if (!this.$refs.hasOwnProperty(prop)) continue;
        this.$refs[prop].init(shop.idBarberShop);
      }
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    toggleCards: function (val) {
      for (var prop in this.$refs) {
        // skip loop if the property is from prototype
        if (!this.$refs.hasOwnProperty(prop)) continue;
        this.$refs[prop].setVisibility(val);
      }
    },
    checkAvaibility: function () {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/dashboard/shop/" +
            this.shops[0].idBarberShop +
            "/enabled",
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          let temp = response.data.data.enabled;
          if (!temp) self.dashboardDisable = true;
          else self.dashboardEnable = true;
          self.toggleCards(false);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backend/Dashboard.vue